import clsx from 'clsx'

function Icon(props) {
  const { id, className, viewBox } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={clsx('icon', className)} fill="none" viewBox={viewBox}>
      <use href={`#${id}`} x="0" y="0" />
    </svg>
  )
}

export default Icon
